import { render } from "./DownloadLiquidation.vue?vue&type=template&id=f5cf6044"
import script from "./DownloadLiquidation.vue?vue&type=script&lang=js"
export * from "./DownloadLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__